import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './lang/zh-CN'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'zh-CN',
  messages: {
    'zh-CN': zhCN
  }
})
